/* eslint-disable consistent-return */
import { useEffect } from "react";
import TagManager from "react-gtm-module";

const GtmProvider = ({ children }) => {
  const gtmId = process.env.REACT_APP_GTM_ID;
  const gtmInIframeEnabled =
    process.env.REACT_APP_GTM_IN_IFRAME_ENABLED === "true";

  useEffect(() => {
    const isInIframe = window.self !== window.top;

    if (!gtmId || (isInIframe && !gtmInIframeEnabled)) return;

    const initGtm = () => {
      if (document.querySelector('meta[name="shopify-api-key"]')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        const script = document.createElement("script");
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
        document.head.appendChild(script);
      } else {
        TagManager.initialize({ gtmId });
      }
    };

    const id =
      typeof requestIdleCallback !== "undefined"
        ? requestIdleCallback(initGtm, { timeout: 2000 })
        : setTimeout(initGtm, 0);

    return () => {
      if (typeof cancelIdleCallback !== "undefined") {
        cancelIdleCallback(id);
      } else {
        clearTimeout(id);
      }
    };
  }, [gtmId, gtmInIframeEnabled]);

  return children;
};

export default GtmProvider;
